import { useState, useEffect } from 'react';

const normalize = <T,>(value: T): T =>
  typeof value === 'string' ? (value.trim() as T) : value;

export function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(normalize(value));

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(normalize(value));
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
